export const scrollToTop = () => {
  document.getElementById("wizard-step-container")?.scrollIntoView();
};
